import React, { useState, useEffect } from 'react';
import { Modal, Table, Select, Button, Space, message, Tag, Spin, Descriptions } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const { Option } = Select;

// 需要审批的字段配置
const APPROVAL_FIELDS = [
  // VBP全流程管理 - CV领域 (5个季度)
  { field: 'hcv_pi_q4_2025_quantity_ratio', label: 'CV 25年Q4数量比', category: 'VBP全流程管理 - CV领域' },
  { field: 'hcv_pi_q4_2025_amount_ratio', label: 'CV 25年Q4金额比', category: 'VBP全流程管理 - CV领域' },
  { field: 'hcv_pi_q1_2026_quantity_ratio', label: 'CV 26年Q1数量比', category: 'VBP全流程管理 - CV领域' },
  { field: 'hcv_pi_q1_2026_amount_ratio', label: 'CV 26年Q1金额比', category: 'VBP全流程管理 - CV领域' },
  { field: 'hcv_pi_q2_2026_quantity_ratio', label: 'CV 26年Q2数量比', category: 'VBP全流程管理 - CV领域' },
  { field: 'hcv_pi_q2_2026_amount_ratio', label: 'CV 26年Q2金额比', category: 'VBP全流程管理 - CV领域' },
  { field: 'hcv_pi_q3_2026_quantity_ratio', label: 'CV 26年Q3数量比', category: 'VBP全流程管理 - CV领域' },
  { field: 'hcv_pi_q3_2026_amount_ratio', label: 'CV 26年Q3金额比', category: 'VBP全流程管理 - CV领域' },
  { field: 'hcv_pi_q4_2026_quantity_ratio', label: 'CV 26年Q4数量比', category: 'VBP全流程管理 - CV领域' },
  { field: 'hcv_pi_q4_2026_amount_ratio', label: 'CV 26年Q4金额比', category: 'VBP全流程管理 - CV领域' },
  // VBP全流程管理 - 其他领域 (5个季度)
  { field: 'cns_q4_2025_quantity_ratio', label: '其他领域 25年Q4数量比', category: 'VBP全流程管理 - 其他领域' },
  { field: 'cns_q4_2025_amount_ratio', label: '其他领域 25年Q4相关领域', category: 'VBP全流程管理 - 其他领域' },
  { field: 'cns_q1_2026_quantity_ratio', label: '其他领域 26年Q1数量比', category: 'VBP全流程管理 - 其他领域' },
  { field: 'cns_q1_2026_amount_ratio', label: '其他领域 26年Q1相关领域', category: 'VBP全流程管理 - 其他领域' },
  { field: 'cns_q2_2026_quantity_ratio', label: '其他领域 26年Q2数量比', category: 'VBP全流程管理 - 其他领域' },
  { field: 'cns_q2_2026_amount_ratio', label: '其他领域 26年Q2相关领域', category: 'VBP全流程管理 - 其他领域' },
  { field: 'cns_q3_2026_quantity_ratio', label: '其他领域 26年Q3数量比', category: 'VBP全流程管理 - 其他领域' },
  { field: 'cns_q3_2026_amount_ratio', label: '其他领域 26年Q3相关领域', category: 'VBP全流程管理 - 其他领域' },
  { field: 'cns_q4_2026_quantity_ratio', label: '其他领域 26年Q4数量比', category: 'VBP全流程管理 - 其他领域' },
  { field: 'cns_q4_2026_amount_ratio', label: '其他领域 26年Q4相关领域', category: 'VBP全流程管理 - 其他领域' },
  // 省联盟扩围相关 - 已隐藏
  // { field: 'province_management_2026', label: '26年是否扩围VBP产品', category: '省联盟扩围相关' },
  // { field: 'province_coordination', label: '可多华是否纳入省联盟采购', category: '省联盟扩围相关' },
  // 红黄标管控政策
  { field: 'marked_products', label: '已标注产品', category: '红黄标管控政策' },
  { field: 'marked_red_products', label: '标红产品', category: '红黄标管控政策' },
  { field: 'unmarked_yellow_products', label: '未被标黄产品', category: '红黄标管控政策' },
  { field: 'management_plan', label: '管理方案', category: '红黄标管控政策' },
  { field: 'has_policy_document', label: '是否有明确政策发文', category: '红黄标管控政策' },
  { field: 'clarified_total_amount_assessment', label: '是否有官方明确澄清（不考核分子式）', category: '红黄标管控政策' },
  { field: 'price_policy_2', label: '是否改善弹窗警示内容', category: '红黄标管控政策' },
  // { field: 'price_policy_3', label: '是否延长执行窗口期', category: '红黄标管控政策' }, // 已隐藏
  // { field: 'price_policy_4', label: '是否明确Q4前不追溯医疗机构数据', category: '红黄标管控政策' }, // 已隐藏
  // { field: 'price_policy_5', label: '是否明确管理方案', category: '红黄标管控政策' }, // 已隐藏
  { field: 'amount_ratio_red', label: '红金额比例', category: '红黄标管控政策' },
  { field: 'amount_ratio_red_yellow', label: '红黄金额比例', category: '红黄标管控政策' },
  { field: 'explanation_dimension', label: '补充说明（是否有其他政策突破性的优化考核特例）', category: '红黄标管控政策' },
  // { field: 'in_key_monitoring_list', label: '是否被纳入重点监管名单', category: '红黄标管控政策' }, // 已隐藏
];

/**
 * 审批表单组件
 * @param {boolean} visible - 是否显示
 * @param {object} record - 待审批的数据记录
 * @param {string} action - 操作类型 'create' 或 'update'
 * @param {object} oldData - 旧数据（仅update时有值）
 * @param {function} onCancel - 取消回调
 * @param {function} onSuccess - 成功回调
 */
const ApprovalForm = ({ visible, record, action, oldData, onCancel, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [approvalDetails, setApprovalDetails] = useState([]);
  const navigate = useNavigate();
  const { logout } = useAuth();

  useEffect(() => {
    if (visible && record) {
      console.log('=== ApprovalForm 开始初始化 ===');
      console.log('action:', action);
      console.log('record:', record);
      console.log('oldData:', oldData);
      
      // 初始化审批详情
      // 关键逻辑：只显示在pending_changes(oldData)中记录的字段
      const details = APPROVAL_FIELDS
        .filter(fieldConfig => {
          const newValue = record[fieldConfig.field];
          const oldValue = oldData ? oldData[fieldConfig.field] : null;
          
          console.log(`检查字段 ${fieldConfig.field}:`, {
            newValue,
            oldValue,
            hasOldData: oldData && (fieldConfig.field in oldData),
          });
          
          // 对于更新操作且有旧数据（pending_changes）
          if (action === 'update' && oldData) {
            // 只显示在pending_changes中记录的字段
            // 这些字段是尚未审批或被拒绝后重新修改的字段
            if (fieldConfig.field in oldData) {
              const newVal = (newValue || '').toString();
              const oldVal = (oldValue || '').toString();
              const isChanged = newVal !== oldVal;
              console.log(`  -> 在pending_changes中: newVal="${newVal}", oldVal="${oldVal}", isChanged=${isChanged}`);
              // 只显示确实有变更的字段（新旧值不同）
              return isChanged;
            }
            // 不在pending_changes中的字段不显示（已审批通过的字段）
            return false;
          }
          
          // 对于新增操作或没有旧数据的情况，只包含有值的字段
          const hasValue = newValue !== null && newValue !== undefined && newValue !== '';
          console.log(`  -> 有值检查: hasValue=${hasValue}`);
          return hasValue;
        })
        .map(fieldConfig => ({
          field: fieldConfig.field,
          fieldLabel: fieldConfig.label,
          category: fieldConfig.category,
          oldValue: oldData && (fieldConfig.field in oldData) ? (oldData[fieldConfig.field] || '-') : '-',
          newValue: record[fieldConfig.field] || '-',
          status: 'pending', // pending, approved, rejected
          comment: '',
        }));
      
      console.log('审批详情初始化完成:', {
        action,
        hasOldData: !!oldData,
        detailsCount: details.length,
        details: details.map(d => ({ field: d.field, oldValue: d.oldValue, newValue: d.newValue }))
      });
      console.log('=== ApprovalForm 初始化结束 ===');
      
      setApprovalDetails(details);
    }
  }, [visible, record, oldData, action]);

  const handleStatusChange = (field, status) => {
    setApprovalDetails(prev => 
      prev.map(detail => 
        detail.field === field ? { ...detail, status } : detail
      )
    );
  };

  // 一键全部通过
  const handleApproveAll = () => {
    setApprovalDetails(prev => 
      prev.map(detail => ({ ...detail, status: 'approved' }))
    );
    message.success('已将所有字段设置为通过');
  };

  // 一键全部不通过
  const handleRejectAll = () => {
    setApprovalDetails(prev => 
      prev.map(detail => ({ ...detail, status: 'rejected' }))
    );
    message.success('已将所有字段设置为不通过');
  };

  const handleSubmit = async () => {
    // 检查是否所有字段都已审批
    const pendingFields = approvalDetails.filter(d => d.status === 'pending');
    if (pendingFields.length > 0) {
      message.warning('请完成所有字段的审批');
      return;
    }

    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const response = await fetch('/api/approval/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({
          policyDataId: record.id,
          action: action,
          approvalDetails: approvalDetails,
        }),
      });

      if (response.status === 401 || response.status === 403) {
        // Token失效或无权限
        message.error('登录已过期，请重新登录');
        logout();
        navigate('/login', { replace: true });
        return;
      }

      const result = await response.json();
      
      if (result.success) {
        message.success('审批提交成功');
        onSuccess(result);
      } else {
        message.error(result.message || '审批提交失败');
      }
    } catch (error) {
      console.error('提交审批失败:', error);
      message.error('提交审批失败');
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: '分类',
      dataIndex: 'category',
      key: 'category',
      width: 150,
      render: (text, record, index) => {
        // 合并相同分类的单元格
        const sameCategoryItems = approvalDetails.filter(d => d.category === text);
        const firstIndex = approvalDetails.findIndex(d => d.category === text);
        if (index === firstIndex) {
          return {
            children: text,
            props: { rowSpan: sameCategoryItems.length },
          };
        }
        return { children: null, props: { rowSpan: 0 } };
      },
    },
    {
      title: '字段',
      dataIndex: 'fieldLabel',
      key: 'fieldLabel',
      width: 150,
    },
    {
      title: '原值',
      dataIndex: 'oldValue',
      key: 'oldValue',
      width: 100,
      render: (text) => text || '-',
    },
    {
      title: '新值',
      dataIndex: 'newValue',
      key: 'newValue',
      width: 100,
      render: (text) => <span style={{ color: '#1890ff', fontWeight: 'bold' }}>{text || '-'}</span>,
    },
    {
      title: '审批结果',
      dataIndex: 'status',
      key: 'status',
      width: 200,
      render: (status, record) => (
        <Select
          value={status}
          onChange={(value) => handleStatusChange(record.field, value)}
          style={{ width: '100%' }}
          placeholder="请选择"
        >
          <Option value="pending">
            <Tag color="default">待审批</Tag>
          </Option>
          <Option value="approved">
            <Tag color="success" icon={<CheckCircleOutlined />}>通过</Tag>
          </Option>
          <Option value="rejected">
            <Tag color="error" icon={<CloseCircleOutlined />}>不通过</Tag>
          </Option>
        </Select>
      ),
    },
  ];

  // 计算审批统计
  const approvedCount = approvalDetails.filter(d => d.status === 'approved').length;
  const rejectedCount = approvalDetails.filter(d => d.status === 'rejected').length;
  const pendingCount = approvalDetails.filter(d => d.status === 'pending').length;

  return (
    <Modal
      title={
        <div>
          <span>审批确认</span>
          <span style={{ marginLeft: '16px', fontSize: '14px', color: '#666', fontWeight: 'normal' }}>
            {record && `【${record.division || '-'}】【${record.province || '-'}】`}
          </span>
        </div>
      }
      open={visible}
      onCancel={onCancel}
      width={800}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          取消
        </Button>,
        <Button 
          key="submit" 
          type="primary" 
          loading={loading}
          onClick={handleSubmit}
          disabled={pendingCount > 0}
        >
          提交审批
        </Button>,
      ]}
    >
      {record && (
        <div style={{ marginBottom: '16px' }}>
          <Descriptions size="small" column={3} bordered>
            <Descriptions.Item label="编辑者">{record.editor_name || record.ma_name}</Descriptions.Item>
            <Descriptions.Item label="MA姓名">{record.ma_name}</Descriptions.Item>
            <Descriptions.Item label="RMA姓名">{record.rma_name}</Descriptions.Item>
          </Descriptions>
        </div>
      )}

      <div style={{ marginBottom: '16px' }}>
        <Space>
          <span>审批进度：</span>
          <Tag color="orange">{pendingCount} 待审批</Tag>
          <Tag color="green">{approvedCount} 通过</Tag>
          <Tag color="red">{rejectedCount} 不通过</Tag>
          <Button 
            type="primary" 
            size="small" 
            icon={<CheckCircleOutlined />}
            onClick={handleApproveAll}
            style={{ marginLeft: '16px' }}
          >
            一键全部通过
          </Button>
          <Button 
            danger 
            size="small" 
            icon={<CloseCircleOutlined />}
            onClick={handleRejectAll}
          >
            一键全部不通过
          </Button>
        </Space>
      </div>

      <Table
        columns={columns}
        dataSource={approvalDetails}
        rowKey="field"
        pagination={false}
        size="small"
        bordered
        scroll={{ y: 400 }}
      />
    </Modal>
  );
};

export default ApprovalForm;
